import { v4 as uuidv4 } from 'uuid';

const GUEST_ID_KEY = 'guest_id';
const COOKIE_EXPIRY = 365; // days

class GuestSession {
  static getGuestId() {
    let guestId = this.getCookie(GUEST_ID_KEY);
    
    if (!guestId) {
      guestId = localStorage.getItem(GUEST_ID_KEY);
    }
    
    if (!guestId) {
      guestId = this.generateGuestId();
      this.saveGuestId(guestId);
    }
    
    return guestId;
  }

  static generateGuestId() {
    return uuidv4();
  }

  static saveGuestId(guestId) {
    this.setCookie(GUEST_ID_KEY, guestId, COOKIE_EXPIRY);
    localStorage.setItem(GUEST_ID_KEY, guestId);
  }

  static clearGuestId() {
    this.deleteCookie(GUEST_ID_KEY);
    localStorage.removeItem(GUEST_ID_KEY);
  }

  static isGuest() {
    return !this.isLoggedIn();
  }

  static isLoggedIn() {
    return !!localStorage.getItem('pm-user-data');
  }

  static getUserId() {
    const userData = localStorage.getItem('pm-user-data');
    if (userData) {
      try {
        const user = JSON.parse(userData);
        return user._id || user.id;
      } catch {
        return null;
      }
    }
    return null;
  }

  static setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
  }

  static getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    }
    return null;
  }

  static deleteCookie(name) {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
  }

  static getHeaders() {
    const headers = {
      'Content-Type': 'application/json',
    };

    if (this.isLoggedIn()) {
      const token = localStorage.getItem('token');
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }
    }

    return headers;
  }

  static getRequestBody(data = {}) {
    const body = { ...data };

    if (this.isLoggedIn()) {
      const userId = this.getUserId();
      if (userId) {
        body.userId = userId;
      }
    } else {
      body.guestId = this.getGuestId();
    }

    return body;
  }

  static getIdentifier() {
    if (this.isLoggedIn()) {
      return { identifier: this.getUserId(), type: 'user' };
    }
    return { identifier: this.getGuestId(), type: 'guest' };
  }
}

export default GuestSession;